import {
  PlannerBundle,
  PlannerOrder,
  WindowGroups,
} from 'pages/planner/utils/usePlannerData';
import React, { useEffect, useState } from 'react';

interface PlannerFilterWindowProps {
  orders: PlannerOrder[][];
  bundles: PlannerBundle[];
  fetchedOrders: PlannerOrder[];
  windowGroups: WindowGroups;
  selectedWindows: string[];
  onChange: (newWindows: Array<string>) => void;
}

export const PlannerFilterWindow = ({
  fetchedOrders,
  ...props
}: PlannerFilterWindowProps) => {
  const [windowDataMap, setWindowDataMap] =
    useState<Map<string, { bundle: number; order: number }>>();

  /* Map all Window data */
  useEffect(() => {
    const windowData = new Map();

    const addNewWindowGroup = (windowGroup: string) => {
      windowData.set(windowGroup, {
        bundle: 0,
        order: 0,
      });
    };

    props.orders.map(groupedOrders => {
      groupedOrders.map(order => {
        if (!windowData.has(order.window)) {
          addNewWindowGroup(order.window);
        }

        /* Increase the order count */
        const newData = windowData.get(order.window);
        newData.order++;
        windowData.set(order.window, newData);

        return order;
      });

      return groupedOrders;
    });

    props.bundles.map(bundle => {
      bundle.orders.map(groupedOrders => {
        groupedOrders.map(order => {
          if (!windowData.has(order.window)) {
            addNewWindowGroup(order.window);
          }

          /* Increase the order count */
          const newData = windowData.get(order.window);
          newData.bundle++;
          windowData.set(order.window, newData);

          return order;
        });

        return groupedOrders;
      });

      return bundle;
    });

    setWindowDataMap(windowData);
  }, [props.bundles, props.orders, props.windowGroups]);

  const onWindowChange = (window: string) => {
    const newSelectedWindow = [...props.selectedWindows];

    const indexOfChosenWindow = newSelectedWindow.indexOf(window);
    const chosenWindowHasBeenSelected = indexOfChosenWindow >= 0;

    if (chosenWindowHasBeenSelected) {
      /* Remove the Window from SelectedWindow */
      newSelectedWindow.splice(indexOfChosenWindow, 1);
    } else {
      /* Add the Window to SelectedWindow */
      newSelectedWindow.push(window);
    }

    props.onChange(newSelectedWindow);
  };

  /* Static Data */
  const numberBundledOfOrders = fetchedOrders.filter(
    order => order.bundleId
  ).length;
  const numberOfOrders = fetchedOrders.length;

  if (windowDataMap) {
    return (
      <table className="windows">
        <thead>
          <tr>
            <th />
            <th />
            <th>Bundled: {numberBundledOfOrders}</th>
            <th>Not bundled: {numberOfOrders - numberBundledOfOrders}</th>
            <th>Total orders: {numberOfOrders}</th>
          </tr>
        </thead>
        <tbody>
          {[...windowDataMap].sort().map(([windowGroup, windowData], index) => (
            <tr
              key={`window-filter-${index}`}
              onClick={() => onWindowChange(windowGroup)}
            >
              <td>
                <input
                  type="checkbox"
                  checked={props.selectedWindows.includes(windowGroup)}
                  onChange={() => undefined}
                />
              </td>
              <td>{windowGroup}</td>
              <td>{windowData.bundle}</td>
              <td>{windowData.order}</td>
              <td>{windowData.order + windowData.bundle} </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  return <></>;
};
